import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: 'Home' },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/OnboardingView.vue'),
    meta: { title: 'Welcome', public: true },
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import('@/views/QuizView.vue'),
    meta: { title: 'Personality Quiz' },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { title: 'Your Profile' },
  },
  {
    path: '/people',
    name: 'people',
    component: () => import('@/views/PeopleView.vue'),
    meta: { title: 'Your People' },
  },
  {
    path: '/analyze',
    name: 'analyze',
    component: () => import('@/views/AnalyzeView.vue'),
    meta: { title: 'New Conversation' },
  },
  {
    path: '/analyses',
    name: 'all-analyses',
    component: () => import('@/views/AllAnalysesView.vue'),
    meta: { title: 'All Analyses' },
  },
  {
    path: '/results/:id',
    name: 'results',
    component: () => import('@/views/ResultsView.vue'),
    meta: { title: 'Results' },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/AccountView.vue'),
    meta: { title: 'My Profile' },
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('@/views/BillingView.vue'),
    meta: { title: 'Plan & Billing' },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { title: 'Admin' },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/DisclaimerView.vue'),
    meta: { title: 'About Inflection', public: true },
  },
  {
    path: '/coach',
    name: 'coach-hub',
    component: () => import('@/views/CoachHubView.vue'),
    meta: { title: 'Coach' },
  },
  {
    path: '/coach/personal',
    name: 'personal-coach',
    component: () => import('@/views/PersonalCoachView.vue'),
    meta: { title: 'Personal Coach' },
  },
  {
    path: '/growth',
    name: 'my-growth',
    component: () => import('@/views/MyGrowthView.vue'),
    meta: { title: 'My Growth' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyView.vue'),
    meta: { title: 'Privacy Policy', public: true },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/TermsView.vue'),
    meta: { title: 'Terms of Service', public: true },
  },
  {
    path: '/data-request',
    name: 'data-request',
    component: () => import('@/views/DataRequestView.vue'),
    meta: { title: 'Data Request', public: true },
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/FeedbackView.vue'),
    meta: { title: 'Feedback' },
  },
  {
    path: '/couple',
    name: 'couple',
    component: () => import('@/views/CoupleView.vue'),
    meta: { title: 'Couple Mode' },
  },
  {
    path: '/couple/invite',
    name: 'couple-invite',
    component: () => import('@/views/CoupleInviteView.vue'),
    meta: { title: 'Invite Partner' },
  },
  {
    path: '/couple/join/:code',
    name: 'couple-join',
    component: () => import('@/views/CoupleJoinView.vue'),
    meta: { title: 'Join Partner', public: true },
  },
  {
    path: '/couple/report',
    name: 'couple-report',
    component: () => import('@/views/CoupleReportView.vue'),
    meta: { title: 'Couple Report' },
  },
  {
    path: '/couple/coach',
    name: 'couple-coach',
    component: () => import('@/views/CoupleCoachView.vue'),
    meta: { title: 'Couple Coach' },
  },
  {
    path: '/couple/business/setup',
    name: 'business-setup',
    component: () => import('@/views/BusinessSetupView.vue'),
    meta: { title: 'Business Setup' },
  },
  {
    path: '/couple/coach/private',
    name: 'couple-private-coach',
    component: () => import('@/views/CouplePrivateCoachView.vue'),
    meta: { title: 'Private Coach' },
  },
  {
    path: '/mentor',
    name: 'mentor',
    component: () => import('@/views/MentorView.vue'),
    meta: { title: 'Mentors' },
  },
  {
    path: '/mentor/register',
    name: 'mentor-register',
    component: () => import('@/views/MentorRegisterView.vue'),
    meta: { title: 'Become a Mentor' },
  },
  {
    path: '/mentor/browse/:teamId',
    name: 'mentor-browse',
    component: () => import('@/views/MentorBrowseView.vue'),
    meta: { title: 'Browse Mentors' },
  },
  {
    path: '/mentor/chat/:coupleId',
    name: 'mentor-chat',
    component: () => import('@/views/MentorChatView.vue'),
    meta: { title: 'Mentor Chat' },
  },
  {
    path: '/mentor/dashboard',
    name: 'mentor-dashboard',
    component: () => import('@/views/MentorDashboardView.vue'),
    meta: { title: 'Mentor Dashboard' },
  },
  {
    path: '/teams',
    name: 'teams',
    component: () => import('@/views/TeamsView.vue'),
    meta: { title: 'Teams' },
  },
  {
    path: '/teams/create',
    name: 'team-create',
    component: () => import('@/views/TeamCreateView.vue'),
    meta: { title: 'Create Team' },
  },
  {
    path: '/teams/join/:code',
    name: 'team-join',
    component: () => import('@/views/TeamJoinView.vue'),
    meta: { title: 'Join Team', public: true },
  },
  {
    path: '/teams/:teamId/setup',
    name: 'team-setup',
    component: () => import('@/views/TeamSetupView.vue'),
    meta: { title: 'Team Setup' },
  },
  {
    path: '/teams/:teamId',
    name: 'team-dashboard',
    component: () => import('@/views/TeamDashboardView.vue'),
    meta: { title: 'Team Dashboard' },
  },
  {
    path: '/teams/:teamId/coach',
    name: 'team-coach',
    component: () => import('@/views/TeamCoachView.vue'),
    meta: { title: 'Team Coach' },
  },
  {
    path: '/teams/:teamId/settings',
    name: 'team-settings',
    component: () => import('@/views/TeamSettingsView.vue'),
    meta: { title: 'Team Settings' },
  },
  {
    path: '/teams/:teamId/health',
    name: 'team-health',
    component: () => import('@/views/TeamHealthView.vue'),
    meta: { title: 'Team Health' },
  },
  {
    path: '/teams/:teamId/hiring',
    name: 'team-hiring',
    component: () => import('@/views/TeamHiringView.vue'),
    meta: { title: 'Hiring Lens' },
  },
  {
    path: '/sport/:teamId/dashboard',
    name: 'sport-dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { title: 'Squad Dashboard' },
  },
  {
    path: '/teams/:teamId/dashboard',
    name: 'team-desktop-dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { title: 'Team Dashboard' },
  },
  {
    path: '/redeem',
    name: 'redeem',
    component: () => import('@/views/RedeemView.vue'),
    meta: { title: 'Redeem Code', public: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { title: 'Sign In', public: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

router.beforeEach(async (to, _from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} | Inflection`;
  }

  // Public routes are always accessible
  if (to.meta.public) {
    next();
    return;
  }

  // Check auth state
  const { useAuthStore } = await import('@/stores/auth.store');
  const auth = useAuthStore();

  // Wait for auth to finish loading (max 3 seconds)
  if (auth.loading) {
    await new Promise<void>((resolve) => {
      const check = setInterval(() => {
        if (!auth.loading) {
          clearInterval(check);
          resolve();
        }
      }, 50);
      setTimeout(() => { clearInterval(check); resolve(); }, 3000);
    });
  }

  // Not authenticated → send to onboarding (unless going home)
  if (!auth.isAuthenticated) {
    // Allow home page but redirect to welcome if no profile exists
    if (to.path === '/') {
      const { useProfileStore } = await import('@/stores/profile.store');
      const profile = useProfileStore();
      if (!profile.hasProfile) {
        next('/welcome');
        return;
      }
    }
    // Block protected routes
    if (!to.meta.public && to.path !== '/') {
      next('/welcome');
      return;
    }
  }

  next();
});

export default router;
